import { useEffect, useState } from "react";
import "./image-overlays-controls.scss";
import FormField from "../../../forms/FormField/FormField";
import Toggle from "../../../forms/Toggle/Toggle";
import CustomiseFeature from "../../../../containers/CustomiseFeature/CustomiseFeature";

const ImageOverlaysControls = (props) => {
    const [updateForcer, setUpdateForcer] = useState(0);
    const forceUpdate = () => setUpdateForcer(updateForcer + 1);

    const [editingXIndex, setEditingXIndex] = useState(-1);
    const [editingYIndex, setEditingYIndex] = useState(-1);

    const featureVars = props.featureVars;
    const customisationVars = props.customisationData;
    const imageOverlaysData = customisationVars?.customImageOverlay?.overlayImageFiles?.customImageFile;

    return (
        <div className="fl-column">
            {imageOverlaysData && imageOverlaysData.length > 0 &&
                <>
                    {imageOverlaysData.map((imageOverlay, index) => {
                        return (
                            <div key={index} className="fl-column no-gap">
                                {index > 0 && <hr />}
                                <div className="form-field-content label"><h4>{imageOverlay.name}</h4></div>
                                <div className="fl-row">
                                    <div className="fl-column">
                                        <div className="form-field-content label"></div>
                                        <div className="shrink">
                                            <Toggle
                                                label={"Enabled"}
                                                currentState={imageOverlay.enabled}
                                                toggleFunc={
                                                    (e) => {
                                                        console.log('Toggling image overlay enabled for ', imageOverlay);
                                                        if (props.changeCustomisationFunc) {
                                                            props.changeCustomisationFunc(!imageOverlay.enabled, imageOverlay, 'enabled', imageOverlay);
                                                            forceUpdate();
                                                        }
                                                    }
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className={`grow ${editingXIndex === index ? 'iovr-unsaved-field' : ''}`}>
                                        <FormField
                                            label={"X Position"}
                                            type="number"
                                            value={imageOverlay.x || 0}
                                            showError={false}
                                            setFunc={
                                                (val) => {
                                                    imageOverlay.x = parseInt(val);
                                                    setEditingXIndex(index);
                                                    forceUpdate();
                                                }
                                            }
                                            confirmChangeFunc={() => {
                                                if (props.changeCustomisationFunc) {
                                                    props.changeCustomisationFunc(imageOverlay.x, imageOverlay, 'x', imageOverlay);
                                                    setEditingXIndex(-1);
                                                    forceUpdate();
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className={`grow ${editingYIndex === index ? 'iovr-unsaved-field' : ''}`}>
                                        <FormField
                                            label={"Y Position"}
                                            type="number"
                                            value={imageOverlay.y || 0}
                                            showError={false}
                                            setFunc={
                                                (val) => {
                                                    imageOverlay.y = parseInt(val);
                                                    setEditingYIndex(index);
                                                    forceUpdate();
                                                }
                                            }
                                            confirmChangeFunc={() => {
                                                if (props.changeCustomisationFunc) {
                                                    props.changeCustomisationFunc(imageOverlay.y, imageOverlay, 'y', imageOverlay);
                                                    setEditingYIndex(-1);
                                                    forceUpdate();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </>
            }
            {(!imageOverlaysData || imageOverlaysData.length === 0) &&
                <div className="light-text bold-text"><h4>No image overlays found.</h4></div>
            }
        </div>
    )
}

export default ImageOverlaysControls;